const icon = new URL('../../icons/wall.png', import.meta.url).href

export default {
  type: 'floor-plate',
  description: 'floor plate for multi-story layout',
  group: '3D' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'floor-plate',
    left: 100,
    top: 100,
    width: 500,
    height: 500,
    depth: 2,
    fillStyle: '#e8e8e8',
    strokeStyle: '#999999',
    alpha: 0.7
  }
}
